// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3M50K","label":"LabeledBox_label__3rV23"};